import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../../src/lib/component-base';
import { handleFormInputValue } from '../../../../../../../redux/actions';
import { dateFormatString } from '../../../../../../../../../src/lib/date-time-format';
import FSDatePicker from '../../../../../../../../../shared/components/FSDatePicker/FSDatePicker';
import { DATA_EXPORTS_EARLIEST_DATE } from '../../../../../../../constants';

@componentBase('DateSelector')
export default class DateSelector extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    inputObjectDefaults: PropTypes.object,
    selectedEndDate: PropTypes.object,
    selectedStartDateInvalid: PropTypes.string,
    selectedEndDateInvalid: PropTypes.string,
    selectedStartDate: PropTypes.object,
    serverDate: PropTypes.object,
    user: PropTypes.object,
  };

  componentWillMount() {
    this.handleEndDateSelect = this.handleEndDateSelect.bind(this);
  }

  handleStartDateSelect = (date) => {
    const { selectedStartDate } = this.props.inputObjectDefaults;
    const input = { ...selectedStartDate, value: date };
    this.props.dispatch(handleFormInputValue(input));
  }

  handleEndDateSelect = (date) => {
    const { selectedEndDate } = this.props.inputObjectDefaults;
    const input = { ...selectedEndDate, value: date };
    this.props.dispatch(handleFormInputValue(input));
  }

  isInvalid = () => {
    const invalid = {
      start: false,
      end: false,
    };
    const {
      selectedEndDateInvalid,
      selectedStartDateInvalid,
    } = this.props;
    if (selectedEndDateInvalid) {
      invalid.end = selectedEndDateInvalid;
    }
    if (selectedStartDateInvalid) {
      invalid.start = selectedStartDateInvalid;
    }
    return invalid;
  }

  dates = () => {
    const dates = {
      selectedStartDate: null,
      selectedEndDate: null,
    };
    const {
      selectedStartDate,
      selectedEndDate,
    } = this.props;

    if (selectedStartDate && selectedStartDate.isValid()) {
      dates.selectedStartDate = selectedStartDate;
    }
    if (selectedEndDate && selectedEndDate.isValid()) {
      dates.selectedEndDate = selectedEndDate;
    }

    return dates;
  }

  endMinDate = () => {
    if (this.props.selectedStartDate) {
      return this.props.selectedStartDate;
    }
    if (this.props.serverDate) {
      return this.props.serverDate;
    }
    return null;
  }

  startMaxDate = () => {
    if (this.props.selectedEndDate) {
      return this.props.selectedEndDate;
    }
    if (this.props.serverDate) {
      return this.props.serverDate;
    }
    return null;
  }

  render() {
    const invalid = this.isInvalid();
    const dates = this.dates();
    return (
      <div className='data-export-date-picker-group row'>
        <div className='date-search col-xs-12 col-sm-4'>
          <div className='date-search-inner'>
            <h4
              className={`${invalid.start ? 'data-export-form-error' : ''}`}
            >
                From {invalid.start || null}
            </h4>
            <FSDatePicker
              className='advanced-search-text-field'
              autoComplete='off'
              key='searchStartDate'
              locale='en'
              dateFormat={dateFormatString(this.props.user)}
              selected={dates.selectedStartDate}
              minDate={DATA_EXPORTS_EARLIEST_DATE}
              maxDate={this.startMaxDate()}
              utcOffset={0}
              onChange={this.handleStartDateSelect}
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
              readOnly={false}
              instanceId='searchStartDate'
            />
          </div>
        </div>

        <div className='date-search col-xs-12 col-sm-offset-2 col-sm-4'>
          <div className='date-search-inner'>
            <h4
              className={`${invalid.end ? 'data-export-form-error' : ''}`}
            >
                To {invalid.end || null}
            </h4>
            <FSDatePicker
              className='advanced-search-text-field'
              autoComplete='off'
              key='searchEndDate'
              locale='en'
              dateFormat={dateFormatString(this.context.currentUser)}
              selected={dates.selectedEndDate}
              minDate={this.endMinDate()}
              maxDate={this.props.serverDate}
              utcOffset={0}
              onChange={this.handleEndDateSelect}
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
              readOnly={false}
              instanceId='searchEndDate'
            />
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/DateAndMultiSelect/children/DateSelector.js